// Actions
export const ACTION_NEWS_BOOKMARK_LIST_EMPTY = 'news_bookmarks_empty';
export const ACTION_NEWS_BOOKMARK_LIST_FILLED = 'news_bookmarks_filled';
export const ACTION_NEWS_FOLLOWERS_CLICK =
  'news_lightbox_with_number_of_followers_click';
export const ACTION_NEWS_SHOW_MORE_ARTICLES = 'news_more_articles_show';
export const ACTION_NEWS_STARRERS_OPEN =
  'news_lightbox_with_number_of_likers_click';
export const ACTION_NEWSPLUS_PURCHASED_ARTICLES_EMPTY =
  'news_purchased_articles_empty';
export const ACTION_NEWSPLUS_PURCHASED_ARTICLES_FILLED =
  'news_purchased_articles_filled';
export const ACTION_NEWSPLUS_PURCHASED_ARTICLES_HIDE =
  'news_newsplus_accordion_hide_purchased_articles';
export const ACTION_NEWSPLUS_PURCHASED_ARTICLES_SHOW =
  'news_newsplus_accordion_show_purchased_articles';

// Channels
export const CHANNEL_INSIDER_PAGE = 'wbm/News_Insider';
export const CHANNEL_NEWS_PAGE = 'wbm/News_NewsPage';

// Context Dimensions
export const CONTEXT_DIMENSION_EXTERNAL_ARTICLE_VIEW =
  'news_publisher_pages_ExternalArticleView';
export const CONTEXT_DIMENSION_EXTERNAL_NEWSPLUS_ARTICLE_VIEW =
  'news_publisher_pages_newsplus_ExternalArticleView';
export const CONTEXT_DIMENSION_EXTERNAL_INSIDER_ARTICLE_VIEW =
  'news_insider_pages_ExternalArticleView';

// Events
export const EVENT_ARTICLE_VIEW = 'EventNewsArticleView';
export const EVENT_BOOKMARK = 'EventBookmark';
export const EVENT_COMMENT_OPEN = 'EventCommentBoxOpen';
export const EVENT_COMMENT_SENT = 'EventCommentSent';
export const EVENT_FOLLOW = 'EventFollow';
export const EVENT_LIKE = 'EventLike';
export const EVENT_NEWS_PUBLISHER_VIEW = 'EventNewsPublisherView';
export const EVENT_SHARE_OPEN = 'EventShareBoxOpen';
// for some reason this is prefixed with "Prop" ¯\_(ツ)_/¯
export const EVENT_TRACK_ACTION = 'PropTrackAction';
export const EVENT_UNBOOKMARK = 'EventUnbookmark';
export const EVENT_UNFOLLOW = 'EventUnfollow';
export const EVENT_UNLIKE = 'EventUnlike';

// Interaction types
export const INTERACTION_TYPE_NEWS_BOOKMARK = 'news_bookmark';
export const INTERACTION_TYPE_NEWS_COMMENT_OPEN = 'news_commentboxopen';
export const INTERACTION_TYPE_NEWS_COMMENT_SENT = 'news_commentsent';
export const INTERACTION_TYPE_NEWS_FOLLOW = 'news_follow';
export const INTERACTION_TYPE_NEWS_LIKE = 'news_like';
export const INTERACTION_TYPE_NEWS_SHARE_OPEN = 'news_shareboxopen';
export const INTERACTION_TYPE_NEWS_UNBOOKMARK = 'news_unbookmark';
export const INTERACTION_TYPE_NEWS_UNFOLLOW = 'news_unfollow';
export const INTERACTION_TYPE_NEWS_UNLIKE = 'news_unlike';

// Page names
export const PAGE_BOOKMARKS = 'bookmarks';
export const PAGE_INSIDER_ARTICLE_COLLECTION = 'article_overview';
export const PAGE_NEWSPLUS_PURCHASED_ARTICLES = 'newsplus_purchased_articles';

// Products
export const PRODUCT_INSIDER_PAGES = 'insider_pages';
export const PRODUCT_KLARTEXT = 'klartext';
export const PRODUCT_NON_KLARTEXT = 'is_not_klartext';
export const PRODUCT_PUBLISHER_PAGES = 'publisher_pages';

// Url parameters
export const PARAM_INSIDER_PROFILE_FROM_IMAGE =
  'news_insider_article_overviewpage_to_profile_from_image_click';
export const PARAM_INSIDER_PROFILE_FROM_TEXT =
  'news_insider_article_overviewpage_to_profile_from_text_click';
export const PARAM_INSIDER_ARTICLE_COLLECTION_FROM_INSIDER_MODULE =
  'profile_news_insider_module_to_insider_article_overviewpage_click';

// Property keys
export const PROP_CHANNEL = 'PropChannel';
export const PROP_CONTEXT_DIMENSION = 'PropContextDimension1';
export const PROP_INTERACTION_TYPE = 'PropInteractionType';
export const PROP_NEWS_ARTICLE_ID = 'PropNewsArticleId';
export const PROP_NEWS_PRODUCT = 'PropNewsProduct';
export const PROP_NEWS_PUBLISHER_ID = 'PropNewsPublisherId';
export const PROP_PAGE_NAME = 'pageName';
export const PROP_SC_O = 'sc_o';

// Types
export const TYPE_EVENT = 'event';
export const TYPE_PAGEVIEW = 'pageview';
